import script from "./MyHoldings.vue?vue&type=script&setup=true&lang=js"
export * from "./MyHoldings.vue?vue&type=script&setup=true&lang=js"

import "./MyHoldings.vue?vue&type=style&index=0&id=14657107&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14657107"]])

export default __exports__